export enum ModalConfirmStep {
  LINK = 'LINK',
  REQUEST = 'REQUEST',
  STATUS = 'STATUS',
}
